import { useNotify, useDataProvider } from 'react-admin';
import { useEffect, useState } from "react";
import InputFieldCustom from '../Commons/InputFieldCustom'
import { useMediaQuery } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Validate from '../Commons/Validate';
import CircularProgress from '@mui/material/CircularProgress';
import BreadCrumbCustom from '../Commons/BreadCrum';
import historyTracker from '../Commons/historyTracker';
import { useNavigate, useLocation } from 'react-router-dom';
import { Style } from '../Commons/Styles.jsx';
import BottomToolBar from '../Commons/BottomToolBar';
import AuthNotification from '../Commons/AuthNotification';
import InternalMenu from '../Commons/InternalMenu';
// TODO: reemplazar por el ícono definitivo de Proveedores cuando esté disponible
import providers from '../Commons/Icons/apps.svg';
import providerList from '../Commons/Icons/book.svg';

import { hasPermissions } from '../Commons/CompanyAuth';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const YesNo = [
    { key: 'false', value: 'No' },
    { key: 'true', value: 'Sí' },
];

const PostCreate = (props) => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const [name, setName] = useState('');
    const [providerType, setProviderType] = useState('false');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [phones, setPhones] = useState('');
    const [fax, setFax] = useState('');
    const [nit, setNit] = useState('');
    const [idCard, setIdCard] = useState('');
    const [employerNumber, setEmployerNumber] = useState('');
    const [paysIVA, setPaysIVA] = useState('false');
    const [isrWithholding, setIsrWithholding] = useState('false');
    const [withholdingAgent, setWithholdingAgent] = useState('false');
    const [taxRegimeCode, setTaxRegimeCode] = useState('4');
    const [acquirer, setAcquirer] = useState('false');
    const [contactPerson, setContactPerson] = useState('');
    const [email, setEmail] = useState('');
    const [comments, setComments] = useState('');
    const [costCenter, setCostCenter] = useState('');
    const [advanceAccount, setAdvanceAccount] = useState('');
    const [payableAccount, setPayableAccount] = useState('');
    const [deferredPayableAccount, setDeferredPayableAccount] = useState('');
    const [transitImportsAccount, setTransitImportsAccount] = useState('');
    const [accountCode, setAccountCode] = useState('');
    const [taxRegimes, setTaxRegimes] = useState([]);
    const [costCenters, setCostCenters] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [openerror, setOpenerror] = useState(false);
    const [message, setMessage] = useState('');
    const [opacity, setOpacity] = useState(1);
    const [displayLoading, setDisplayLoading] = useState('none');
    const [disable, setDisable] = useState(false);
    const [openAuth, setOpenAuth] = useState(false);
    const [auth, setAuth] = useState(false);
    // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
    // "initialLoading" en el return): sin este estado la ventana se veia en blanco
    // (solo el breadcrumb) mientras se traian los permisos y los catalogos.
    const [initialLoading, setInitialLoading] = useState(true);
    const dataProvider = useDataProvider();

    const notify = useNotify();
    const navigate = useNavigate();
    const location = useLocation();

    const handleClickError = () => {
        setOpenerror(true);
    };

    useEffect(() => {
        (async () => {
            try {
                const currentPath = location.pathname;
                historyTracker.addPath(currentPath, 'Proveedores', 2);

                const authdata = { data: hasPermissions('Provider', 'create') };
                if (authdata.data.length === 0) {
                    setAuth(false);
                    setOpenAuth(true);
                    return;
                }

                setAuth(authdata.data[0]);
                setOpenAuth(!authdata.data[0]);

                if (authdata.data[0]) {
                    const [regimesData, centersData, accountsData, bankAccountsData] = await Promise.all([
                        dataProvider.getList('provider/taxregimes', { filter: {}, pagination: {}, sort: {} }),
                        dataProvider.getList('provider/centers', { filter: {}, pagination: {}, sort: {} }),
                        dataProvider.getList('provider/accounts', { filter: {}, pagination: {}, sort: {} }),
                        dataProvider.getList('provider/bankaccounts', { filter: {}, pagination: {}, sort: {} })
                    ]);

                    // El catalogo trae codregimenfiscal + descripcion_regfiscal; si el default
                    // fijo ('4', igual al que trae el propio SP) no aparece en la lista real,
                    // se cae al primer regimen devuelto para no dejar el combo vacio.
                    var taxRegimesList = regimesData.data.map(item => ({ key: item.id, value: item.name }));
                    setTaxRegimes(taxRegimesList);
                    // Actualizacion funcional (lee el taxRegimeCode actual via el callback, no
                    // por closure) para no tener que declarar taxRegimeCode como dependencia de
                    // este efecto -- si se declarara, el propio setTaxRegimeCode de aca abajo
                    // dispararia una segunda corrida del efecto (y un segundo fetch de todos los
                    // catalogos) apenas el default se autoasigna.
                    if (taxRegimesList.length > 0) {
                        setTaxRegimeCode((current) => taxRegimesList.some((item) => item.key === current) ? current : taxRegimesList[0].key);
                    }

                    // Centro de Responsabilidad: se manda el codigo (cod_centro), no el
                    // correlativo interno del catalogo.
                    var costCentersList = centersData.data.map(item => ({ key: item.code, value: `${item.code} - ${item.description}` }));
                    setCostCenters([{ key: '', value: 'Ninguno' }, ...costCentersList]);

                    // Un solo catalogo de cuentas contables alimenta los 4 combos de cuenta
                    // (Anticipo, Por Pagar, Por Pagar Diferido, Transitoria Importaciones).
                    var accountsList = accountsData.data.map(item => ({ key: item.account, value: `${item.account} - ${item.name}` }));
                    setAccounts([{ key: '', value: 'Ninguno' }, ...accountsList]);

                    // Cuenta Bancaria: se manda el codigo_cuenta del catalogo (sp_lista_cbtaban_simple),
                    // no el corre_cbtaban (ese es el correlativo interno del registro, otro dato).
                    var bankAccountsList = bankAccountsData.data.map(item => ({ key: item.accountCode, value: `${item.accountNumber} - ${item.accountName} (${item.bankName})` }));
                    setBankAccounts([{ key: '', value: 'Ninguno' }, ...bankAccountsList]);
                }
            }
            catch {
            }
            finally {
                setInitialLoading(false);
            }
        })();
    }, [dataProvider, location.pathname]);

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenerror(false);
    };

    const PostProvider = async () => {
        let control = 0;

        if (!Validate(name, { required: true }))
            control++;

        if (!Validate(nit, { required: true }))
            control++;

        if (email && !Validate(email, { email: true }))
            control++;

        if (control > 0) {
            setMessage("No se pudo crear el Proveedor")
            handleClickError();
            return;
        }

        setOpacity(0.3);
        setDisable(true);
        setDisplayLoading('block');

        var info = {
            name,
            providerType: providerType === 'true',
            address,
            zipCode,
            phones,
            fax,
            nit,
            idCard,
            employerNumber,
            paysIVA: paysIVA === 'true',
            isrWithholding: isrWithholding === 'true',
            withholdingAgent: withholdingAgent === 'true',
            taxRegimeCode,
            acquirer: acquirer === 'true',
            contactPerson,
            email,
            comments,
            costCenter,
            advanceAccount,
            payableAccount,
            deferredPayableAccount,
            transitImportsAccount,
            accountCode
        }

        dataProvider.create('provider', { data: info })
            .then(() => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                notify('Proveedor creado correctamente')
                navigate('/provider');
            })
            .catch((error) => {
                setOpacity(1);
                setDisable(false);
                setDisplayLoading('none');
                setMessage("No se pudo crear el Proveedor. " + error.toString().replace('HttpError: ', ''));
                handleClickError()
            })
    }

    const handleRedirectProviderList = () => {
        navigate(`/provider`);
    };

    const [openProviders, setOpenProviders] = useState(true);

    const handleClickOpenProviders = () => {
        setOpenProviders(!openProviders);
    };

    const menus = [{
        icon: <img src={providers} alt="logo" style={Style.MenuLogo} />, name: 'Proveedores',
        open: openProviders,
        openAction: handleClickOpenProviders,
        actions: [
            { icon: <img src={providerList} alt="logo" style={Style.MenuLogo} />, name: 'Listado', onClick: handleRedirectProviderList },
        ]
    }];

    return (
        <div class="container">
            <BreadCrumbCustom history={historyTracker.getHistory()} />
            {initialLoading ? (
                // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
                // el mismo CircularProgress que ya se usaba para el guardado (mas abajo,
                // controlado por displayLoading), pero aqui cubre la espera de auth +
                // catalogos, que antes dejaba la pantalla en blanco.
                <div class="Loading" style={{ display: 'block' }}>
                    <CircularProgress size="15rem" />
                </div>
            ) : auth ? (
                <div class="edit">
                    {!isSmall ? (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>) : (
                        <div class="Loading" style={{ display: displayLoading }}>
                            <CircularProgress size="15rem" />
                        </div>
                    )}
                    {!isSmall ? (
                        <div class="container" style={{ opacity: opacity }}>
                            <div class="row">
                                <InputFieldCustom value={name} setValue={setName} col="col-3" width="95%" placeholder="Ingresa el nombre del Proveedor" label="Nombre *" required type="text" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setProviderType} value={providerType} options={YesNo} name="providerType" component="select" label="Tipo Proveedor" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={nit} setValue={setNit} col="col-3" width="95%" placeholder="Ingresa el NIT" label="NIT *" required type="text" />
                                <InputFieldCustom value={idCard} setValue={setIdCard} col="col-3" width="95%" placeholder="Ingresa la Cédula" label="Cédula" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={address} setValue={setAddress} col="col-3" width="95%" placeholder="Ingresa la Dirección" label="Dirección" type="text" />
                                <InputFieldCustom value={zipCode} setValue={setZipCode} col="col-3" width="95%" placeholder="Ingresa el Código Postal" label="Código Postal" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={phones} setValue={setPhones} col="col-3" width="95%" placeholder="Ingresa el Teléfono" label="Teléfono" type="text" />
                                <InputFieldCustom value={fax} setValue={setFax} col="col-3" width="95%" placeholder="Ingresa el Fax" label="Fax" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={employerNumber} setValue={setEmployerNumber} col="col-3" width="95%" placeholder="Ingresa el Número Patronal" label="Número Patronal" type="text" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setTaxRegimeCode} value={taxRegimeCode} options={taxRegimes} component="select" label="Régimen Fiscal" />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setCostCenter} value={costCenter} options={costCenters} component="select" label="Centro de Responsabilidad" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setAccountCode} value={accountCode} options={bankAccounts} component="select" label="Cuenta Bancaria" />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setAdvanceAccount} value={advanceAccount} options={accounts} component="select" label="Cuenta Anticipo" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setPayableAccount} value={payableAccount} options={accounts} component="select" label="Cuenta por Pagar" />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setDeferredPayableAccount} value={deferredPayableAccount} options={accounts} component="select" label="Cuenta por Pagar Diferido" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setTransitImportsAccount} value={transitImportsAccount} options={accounts} component="select" label="Cuenta Transitoria Importaciones" />
                            </div>
                            <div class="row">
                                <InputFieldCustom value={contactPerson} setValue={setContactPerson} col="col-3" width="95%" placeholder="Ingresa la Persona de Contacto" label="Persona Contacto" type="text" />
                                <InputFieldCustom value={email} setValue={setEmail} col="col-3" width="95%" placeholder="Ingresa el Correo Electrónico" label="Correo Electrónico" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom col="col-3" width='95%' setValue={setPaysIVA} value={paysIVA} options={YesNo} name="paysIVA" component="select" label="Paga IVA" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setIsrWithholding} value={isrWithholding} options={YesNo} name="isrWithholding" component="select" label="ISR Retiene" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setWithholdingAgent} value={withholdingAgent} options={YesNo} name="withholdingAgent" component="select" label="Agente Retenedor" />
                                <InputFieldCustom col="col-3" width='95%' setValue={setAcquirer} value={acquirer} options={YesNo} name="acquirer" component="select" label="Adquiriente" />
                            </div>
                            <div class="row">
                                {/* referenceCol="col-3": el resto de la pantalla usa el modulo de
                                    4-por-fila (col-3) -- ver comentario de computeTextareaWidth en
                                    InputFieldCustom.jsx. */}
                                <InputFieldCustom value={comments} setValue={setComments} col="col-12" width="95%" placeholder="Ingresa comentarios" label="Comentarios" name="Comments" type="text" component="textarea" referenceCol="col-3" />
                            </div>
                            <BottomToolBar buttons={[{ auth: true, action: PostProvider, name: 'Crear' }]} disabled={disable} menu={<InternalMenu menus={menus} />} />
                        </div>
                    ) : (
                        <div class="container" style={{ opacity: opacity }}>

                        </div>)
                    }
                    <div class="row" style={Style.Alert}>
                        <div>
                            <Snackbar open={openerror} autoHideDuration={4000} onClose={handleCloseError}>
                                <div>
                                    <Alert onClose={handleCloseError} severity="error" style={Style.AlertMessage} >
                                        {message}
                                    </Alert>
                                </div>
                            </Snackbar>
                        </div>
                    </div>
                </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)}
        </div>
    )
}

export default PostCreate
